/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Tags_No_TagsInputs */

const en_event_tags_no_tags = /** @type {(inputs: Event_Tags_No_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Tags(s) Assigned`)
};

const fr_event_tags_no_tags = /** @type {(inputs: Event_Tags_No_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune etiquette assignee`)
};

const de_event_tags_no_tags = /** @type {(inputs: Event_Tags_No_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Tags zugewiesen`)
};

const it_event_tags_no_tags = /** @type {(inputs: Event_Tags_No_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun tag assegnato`)
};

const ru_event_tags_no_tags = /** @type {(inputs: Event_Tags_No_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метки не назначены`)
};

const es_event_tags_no_tags = /** @type {(inputs: Event_Tags_No_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay etiquetas asignadas`)
};

const zh_cn2_event_tags_no_tags = /** @type {(inputs: Event_Tags_No_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未分配任何标签`)
};

const ja_event_tags_no_tags = /** @type {(inputs: Event_Tags_No_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグが割り当てられていません`)
};

const hi_event_tags_no_tags = /** @type {(inputs: Event_Tags_No_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई टैग आवंटित नहीं किया गया`)
};

const pt_pt2_event_tags_no_tags = /** @type {(inputs: Event_Tags_No_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma etiqueta atribuída`)
};

/**
* | output |
* | --- |
* | "No Tags(s) Assigned" |
*
* @param {Event_Tags_No_TagsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_tags_no_tags = /** @type {((inputs?: Event_Tags_No_TagsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Tags_No_TagsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_tags_no_tags(inputs)
	if (locale === "de") return de_event_tags_no_tags(inputs)
	if (locale === "it") return it_event_tags_no_tags(inputs)
	if (locale === "ru") return ru_event_tags_no_tags(inputs)
	if (locale === "es") return es_event_tags_no_tags(inputs)
	if (locale === "zh-CN") return zh_cn2_event_tags_no_tags(inputs)
	if (locale === "ja") return ja_event_tags_no_tags(inputs)
	if (locale === "hi") return hi_event_tags_no_tags(inputs)
	if (locale === "pt-PT") return pt_pt2_event_tags_no_tags(inputs)
	return en_event_tags_no_tags(inputs)
});